import { getSsoDialog } from 'owa-addins-store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('updateSsoDialogVisibility', function(isVisible: boolean) {
    getSsoDialog().isVisible = isVisible;
});
